/** Shared controls for the device pages, matching the Property Directory's sizing. */
import { cn } from '@pazportal/ui';

export const BTN =
  'inline-flex items-center justify-center min-h-[44px] md:min-h-[36px] px-3 rounded-md text-xs font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-50';
export const BTN_PRIMARY = `${BTN} bg-primary text-text-inverse hover:bg-primary-hover`;
export const INPUT =
  'w-full min-h-[44px] md:min-h-[40px] rounded-md border border-border bg-surface px-3 py-1.5 text-sm text-text focus:outline-none focus:ring-2 focus:ring-primary';

export type FeedbackState = { tone: 'success' | 'error'; text: string };

export function Feedback({ message }: { message: FeedbackState | null }) {
  if (!message) return null;
  return (
    <p role={message.tone === 'error' ? 'alert' : 'status'} className={`text-xs break-words ${message.tone === 'error' ? 'text-error' : 'text-success'}`}>
      {message.text}
    </p>
  );
}

/**
 * Evidence chip. Verified gear shows nothing extra; anything less is labelled
 * so a deduced device is never read as verified.
 */
export function ConfidenceChip({ confidence }: { confidence: string }) {
  if (confidence === 'verified') return null;
  return (
    <span
      className={cn(
        'inline-flex items-center rounded border px-1.5 py-0.5 text-[10.5px] font-medium',
        confidence === 'deduced' ? 'border-border text-text-muted' : 'border-warning text-warning',
      )}
    >
      {confidence[0].toUpperCase() + confidence.slice(1)}
    </span>
  );
}

/** Role name with its colour dot. color_token is a semantic token name, never hex. */
export function RoleDot({ name, token }: { name: string; token: string }) {
  return (
    <span className="inline-flex items-center gap-1.5">
      <span aria-hidden className="h-2 w-2 rounded-full flex-none" style={{ background: `var(--${token})` }} />
      {name}
    </span>
  );
}

export const nullable = (v: string): string | null => {
  const t = v.trim();
  return t === '' ? null : t;
};
